import { useMemo, useState, useEffect } from 'react';
import { getLanguage, type Language } from '@deadpan/shared';
import type { GameState } from '@deadpan/shared';

/**
 * Hook to get localized word and definition based on current language
 */
export function useGameWord(gameState: GameState | null | undefined): {
  word: string | undefined;
  definition: string | undefined;
} {
  const [lang, setLang] = useState<Language>(getLanguage());

  useEffect(() => {
    const handleLanguageChange = () => {
      setLang(getLanguage());
    };
    window.addEventListener('languagechange', handleLanguageChange);
    return () => window.removeEventListener('languagechange', handleLanguageChange);
  }, []);

  return useMemo(() => {
    if (!gameState) {
      return { word: undefined, definition: undefined };
    }
    
    // Get word: prefer current language, fallback to other language if not available
    const word = lang === 'zh' 
      ? (gameState.currentWordZh ?? gameState.currentWord)
      : (gameState.currentWord ?? gameState.currentWordZh);
    
    // Get definition: prefer current language, fallback to other language if not available
    const definition = lang === 'zh'
      ? (gameState.truthDefinitionZh ?? gameState.truthDefinition)
      : (gameState.truthDefinition ?? gameState.truthDefinitionZh);
    
    return {
      word,
      definition,
    };
  }, [gameState, lang]);
}

